module.exports = __webpack_public_path__ + "static/media/ensaLogo.1ae738f7.png";